import { configureStore } from '@reduxjs/toolkit';
import invoicesReducer from '../features/invoices/invoicesSlice';
import logonReducer from '../features/logon/logonSlice';
import userReducer from '../features/user/userSlice';
import toolbarNavigationMenuReducer from '../features/toolbarNavigationMenu/toolbarNavigationMenuSlice';
import proformasReducer from '../features/proformas/ProformasSlice';
import proformaEditorReducer from '../features/proformas/ProformaEditorSlice';
import correctionInvoiceEditorReducer from '../features/correctionInvoices/correctionInvoiceEditorSlice';

export const store = configureStore({
  reducer: {
    invoices: invoicesReducer,
    logon: logonReducer,
    user: userReducer,
    toolbarNavigationMenu: toolbarNavigationMenuReducer,
    proformas: proformasReducer,
    proformaEditor: proformaEditorReducer,
    correctionInvoiceEditor: correctionInvoiceEditorReducer,
  },
});
